/**
 * PROJECT-EDIT-SKELETON.WIDGET
 * Skeleton du chargement de /project/edit, à la place du spinner : l'en-tête (titre, sous-titre), les trois phases
 * (préparation, enquête en cours, terminée) puis les cartes d'étapes de project-edit.widget.tsx.
 * Même largeur et même espacement que les vrais éléments pour que le contenu arrive à sa place.
 */
import Card from "@/components/card"
import Skeleton, { SkeletonShine } from "@/components/skeleton"

const TITLE_WIDTHS: number[] = [240, 200, 280, 220, 260, 190, 250, 230]
const PHASE_LABEL_WIDTHS: number[] = [180, 140, 140]

export default function ProjectEditSkeletonWidget() {
  return (
    <div className="rel" style={{ overflow: "hidden" }}>
      {/* Title and subtitle of the page */}
      <div style={{ marginBottom: 28 }}>
        <Skeleton width={340} height={30} style={{ marginBottom: 14 }} />
        <Skeleton width={420} height={16} />
      </div>

      {/* The three phases of the survey */}
      <div className="flex" style={{ justifyContent: "center", alignItems: "flex-start", gap: 28, marginBottom: 36 }}>
        {PHASE_LABEL_WIDTHS.map((width, i) => (
          <div key={i} className="flex" style={{ alignItems: "flex-start", gap: 28 }}>
            <div className="flex flex-dcol" style={{ alignItems: "center", gap: 14, minWidth: 170 }}>
              <Skeleton width={130} height={110} borderRadius={10} />
              <Skeleton width={width} height={16} />
              {i === 0 && <Skeleton width={110} height={28} borderRadius={14} />}
            </div>
            {i < PHASE_LABEL_WIDTHS.length - 1 && <Skeleton width={22} height={44} borderRadius={4} style={{ marginTop: 44 }} />}
          </div>
        ))}
      </div>

      {/* The steps */}
      {TITLE_WIDTHS.map((width, i) => (
        <Card key={i} isWithoutPadding>
          <div className="flex" style={{ alignItems: "center", gap: 16, padding: "16px 20px" }}>
            <Skeleton width={32} height={32} isCircle />
            <Skeleton width={width} height={16} />
            <div style={{ flex: 1 }} />
            <Skeleton width={70} height={14} />
          </div>
        </Card>
      ))}
      <SkeletonShine />
    </div>
  )
}
